/** A hash router in thirty lines.
  *
  * Hash routing is a deliberate choice: it needs no SPA-fallback rewrite rule,
  * so the same `dist/` folder works unchanged on Cloudflare Pages, Vercel,
  * GitHub Pages under a subpath, or any plain static file server. That is what
  * keeps the app genuinely portable between hosts.
  */

export type Route =
    | { name: 'library' }
    | { name: 'player'; bookId: string }
    | { name: 'settings' };

export function parseHash(hash: string): Route {
    const path = hash.replace(/^#\/?/, '');
    const [head, tail] = path.split('/');
    if (head === 'player' && tail) return { name: 'player', bookId: decodeURIComponent(tail) };
    if (head === 'settings') return { name: 'settings' };
    return { name: 'library' };
}

export function toHash(route: Route): string {
    switch (route.name) {
      case 'player':
        return `#/player/${encodeURIComponent(route.bookId)}`;
      case 'settings':
        return '#/settings';
      default:
        return '#/library';
    }
}

export function currentRoute(): Route {
    return parseHash(window.location.hash);
}

export function navigateTo(route: Route): void {
    const next = toHash(route);
    if (window.location.hash !== next) window.location.hash = next;
}

export function onRouteChange(handler: (route: Route) => void): () => void {
    const listener = () => handler(currentRoute());
    window.addEventListener('hashchange', listener);
    return () => window.removeEventListener('hashchange', listener);
}
